var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[(_vm.isLoading)?_c('Loader',{staticClass:"loader--fullscreen"}):[_c('Sidebar'),_c('div',{staticClass:"main-content"},[_c('Map')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }